import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LoadingFallback from "../../components/LoadingFallback/LoadingFallback";

// Lazy load route components for code splitting
const PAGE_LOADERS = {
  "/": () => import("../HomePage3/HomePage3"),
  "/knowledge-think": () => import("../GalleryPage/GalleryPage"),
  "/ai": () => import("../AIIntelligencePage/AIIntelligencePage"),
  "/contact-us": () => import("../ContactUsPage/ContactUsPage"),
  "/privacy-policy": () => import("../PrivacyPolicyPage/PrivacyPolicyPage"),
  "/terms-condition": () => import("../TermsConditionPage/TermsConditionPage"),
  "/delete-account": () => import("../DeleteAccountPage/DeleteAccountPage"),
};

const LAZY_PAGES = Object.fromEntries(
  Object.entries(PAGE_LOADERS).map(([path, load]) => [path, lazy(load)]),
);
const PRELOADED_PAGES = {};

// Load the page for a URL before the app renders, so that the prerendered
// markup (see scripts/prerender-static-routes.js) is replaced by the page
// itself and not by the loading spinner.
export const preloadPage = (pathname) => {
  const path = pathname.replace(/\/+$/, "") || "/";
  const load = PAGE_LOADERS[path];
  if (!load) return Promise.resolve();
  return load().then(
    (module) => {
      PRELOADED_PAGES[path] = module.default;
    },
    () => {},
  );
};

const Page = ({ path }) => {
  const Component = PRELOADED_PAGES[path] || LAZY_PAGES[path];
  return <Component />;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Page path="/" />} />
            <Route path="home_pepecoin" element={<Page path="/" />} />
            <Route
              path="knowledge-think"
              element={<Page path="/knowledge-think" />}
            />
            <Route path="ai" element={<Page path="/ai" />} />
            <Route path="contact-us" element={<Page path="/contact-us" />} />
            <Route
              path="privacy-policy"
              element={<Page path="/privacy-policy" />}
            />
            <Route
              path="terms-condition"
              element={<Page path="/terms-condition" />}
            />
            <Route
              path="delete-account"
              element={<Page path="/delete-account" />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
